module.exports = __webpack_public_path__ + "static/media/aorte_normale.f5fd62d1.jpg";